module.exports = "<button\n  class=\"btn\"\n  [ngClass]=\"classes\"\n  [type]=\"type\"\n><span class=\"btn-text\">{{btnText}}</span></button>\n"